import {
  Outlet,
  useLocation,
  useOutletContext,
  Navigate,
  useNavigate,
} from "react-router-dom";
import clsx from "clsx";
import { Heading } from "V2.0/common/heading";

export default Pipelines;

export function PipelineRedirectWithSearchParams() {
  const location = useLocation();

  return (
    <Navigate
      to={{ pathname: "v2", search: location.search }}
      replace
    />
  );
}

function Pipelines() {
  const outletContext = useOutletContext();
  const location = useLocation();
  const navigate = useNavigate();

  // const pipelineVersion = location.pathname.includes("/v2") ? "v2" : "v1";

  // const onSectionClick = (version) => {
  //   navigate({ pathname: `${version}`, search: location.search });
  // };

  return (
    <div className="flex flex-col h-full">
      <div className="h-full w-full min-h-0 flex-1">
        <div className="flex h-full">
          {/* <div className="flex flex-col items-center w-20 border-r overflow-scroll h-full">
            {["v1", "v2"].map((version) => {
              const isActiveVersion = version === pipelineVersion;

              return (
                <div
                  className={clsx(
                    `p-2 h-20 min-h-20 w-full flex flex-col gap-y-2 items-center justify-center cursor-pointer`,
                    isActiveVersion && "bg-zinc-950/80 text-gray-100",
                    !isActiveVersion &&
                      "hover:bg-gray-200 hover:outline outline-gray-300",
                  )}
                  onClick={() => onSectionClick(version)}
                >
                  <p>{version}</p>
                </div>
              );
            })}
          </div> */}
          <div className="w-full h-full flex-1 min-w-0 overflow-auto">
            <Outlet context={outletContext} />
          </div>
        </div>
      </div>
    </div>
  );
}
